<template>
    <div class="box" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="order-box">
        <p class="order-info">订单概览</p>
        <div v-if="Data.Orders && Data.Orders.length>0">
          <p class="order-no">订单号:{{Data.Orders[0].OrderId}}</p>
          <div class="pro-info">
            <div class="pro-img">
              <img style="width: 80px;height: 80px;" v-if="Data.Orders[0].ProductImgPath" :src="getPic(Data.Orders[0])">
              <p style="text-align: center;line-height: 80px" v-else>暂无图片</p>
            </div>
            <div class="pro-name">
              {{Data.Orders[0].ProductName}}
            </div>
            <div class="pro-num">
              ×{{Data.Orders[0].Quantity}}
            </div>
          </div>
          <ul class="ul-li">
            <li>
              <div><img src="/static/images/HomeTH/house.png"></div>
              <div>下单企业：{{Data.CompanyName}}</div>
            </li>
            <li>
              <div><img src="/static/images/HomeTH/position.png"></div>
              <div>销售单位：{{Data.Orders[0].WarehouseName}}</div>
            </li>
            <li>
              <div><img src="/static/images/HomeTH/car.png"></div>
              <div>提货方式：自提</div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="Data.Payment && Data.Payment.length>0" class="money-box">
        <p class="price">￥{{Data.Orders[0].Amount}}</p>
        <div style="padding-left: 10px;">
          <p class="time">剩余支付时间<span style="color: red;margin-left: 10px;">{{Data.timeStr}}</span></p>
          <p class="name">账户可用余额</p>
          <p class="money">¥{{Data.Payment[0].Balance}}</p>
          <p class="name">信用</p>
          <p class="money">¥{{Data.Payment[0].Credit}}</p>
          <p style="font-size: 18px;font-weight: 600;margin-top: 40px;">支付验证<span style="font-size: 14px;font-weight:
           400">（如果未设置支付密码请先去<span @click="changePayPWD" style="color: #409EFF;cursor: pointer">设置</span>）
          </span></p>
          <el-input style="margin-top: 15px;" placeholder="请输入支付密码" maxlength="6" v-model="form.Vcode" show-password></el-input>
          <el-button class="btn-pay" type="primary" @click="toPay">支 付</el-button>
        </div>
      </div>
      <el-dialog center
        title='设置支付密码'
        :visible.sync='dialogVisible'
        >
        <el-form ref="PayForm" :model="PayForm" label-width="135px" :rules="PayRules">
          <el-form-item label="手机号：">
            {{ PayForm.Phone }}
          </el-form-item>
          <el-form-item label="验证码：" prop="VCode">
            <el-input v-model="PayForm.VCode" placeholder="手机验证码" style="width: 84%;"></el-input>
            <el-button alt="" class="v-code" @click="sendVCode" :disabled="sendVCodeTime > 0">
              {{ sendVCodeTime > 0 ? sendVCodeTime + " 秒" : "发送验证码" }}
            </el-button>
          </el-form-item>
          <el-form-item label="请输入新密码：" prop="Password">
            <el-input v-model="PayForm.Password" placeholder="请输入新密码" clearable type="password"></el-input>
          </el-form-item>
          <el-form-item label="再次输入新密码：" prop="RePassword">
            <el-input v-model="PayForm.RePassword" placeholder="再次输入新密码" clearable type="password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="savePayPwd">保 存</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import Search from '@/components/Search'
  import AutoForm from '@/components/AutoForm'
  import DialogButton from '@/components/Dialogs/DialogButton'
  import DialogPay from '@/components/Dialogs/DialogPay'
    export default {
      components: {
        Search,AutoForm,DialogButton,DialogPay
      },
      props: {
        screen:{
          type: Object,
          default: () => {}
        }
      },
      data() {
        var checkedPayPWD = (rule, value, callback) => {
          let reg = /^[0-9]\d{5}$/;
          if (value === '') {
            callback(new Error('请输入六位数字的支付密码'));
          } else if (!reg.test(value)) {
            callback(new Error('请输入六位数字的支付密码'));
          } else {
            callback();
          }
        };
        var checkedPayRePwd = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入支付密码'));
          } else if (value !== this.PayForm.Password) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        };
        return {
          refreshPriceOrderFlag:false,
          dialogVisible:false,
          refreshPriceOrders:[],
          user:{
            Account: null,
            ContractsCardNumber: null,
            ContractsEmail: null,
            CustomNo: null,
            Name: null,
            CustomId: null,
            EmpName: null,
            UserName: null,
            PasswordLength: null,
            PhoneNumber: null,
            DonationQuota: 0,
            BankName: null,
            Company: null,
            IsManager: false,
            CanUseMoney: null,
            CompanyState: null,
            RealNameState: null,
            PhoneNumberStr: null,
            Password: null,
          },
          PayForm: {
            Phone: '',
            Password: '',
            RePassword: '',
            VCode: '',
            PaymentPassword: ''
          },
          PayRules: {
            Password: [
              {
                required: true,
                message: '请输入新支付密码',
                trigger: 'blur'
              },
              {
                validator: checkedPayPWD,
              }
            ],
            RePassword: [
              {
                required: true,
                message: '请再次输入新支付密码',
                trigger: 'blur'
              },
              {
                validator: checkedPayRePwd,
              }
            ],
            VCode: [
              {
                required: true,
                message: '请输入验证码',
                trigger: 'blur'
              },
              // {
              //   min: 6,
              //   max: 10,
              //   message: '客户号长度应在 6 到 10 个字符之间',
              //   trigger: 'blur'
              // }
            ],
          },

          rules:{
            Vcode: [
              {
                required: true,
                message: '请输入支付密码',
                trigger: 'blur'
              },
              {
                min: 6,
                max: 14,
                message: '短信验证码长度应为6-14个字符',
                trigger: 'blur'
              }
            ],
          },
          form:{
            Vcode:'',
            OrderNo:''
          },
          LoginPortId:'1', // 仓库id
          formTemplate:[
            { col: 12, label: '支付密码', prop: 'Vcode', type: 'password'},
          ],
          url:{
            get:SZH.assets.api + "/Order/GetSAPBalanceForCreateOrder",
            sendPhoneVCodeOld:SZH.assets.api + "/Authen/SendVerifyCode2",
            pay: SZH.assets.api + "/Order/OrderToPay",
            refresh:SZH.assets.api +'/Order/GetSAPBalance',
            refresh2:SZH.assets.api +'/Custom/GetCustomCanUseMonyeForWeb',
            check: SZH.assets.api + "/UnionPay/QueryOrderState",
            toPay:SZH.assets.api + "/UnionPay/Pay",
            hasPayWord:SZH.assets.api + "/Custom/VerfiyExitPayPwd",
            cuttent:SZH.assets.api + '/Custom/GetCurrentDateTime',
            GetRefreshPriceFreezOrderDetail:SZH.assets.api + '/Order/GetRefreshPriceFreezOrderDetail',
            SendVerifyCodeForWeb: SZH.assets.api + "/Custom/SendVerifyCodeForWeb",//支付密码的验证码发送
            SetCustomPaymentPassword: SZH.assets.api + "/Custom/SetCustomPaymentPassword",//支付密码保存
            loadData: SZH.assets.api + "/Custom/GetCustomInfoForWeb",

          },
          isEdit:true,
          canEdit:true,
          Data:{
            Amount:'',
            Orders:[],
            PayEndTime:'',
            timeStr:'',
            Payment:[],
            CompanyName:''
          },
          OffLine:false,
          text:'text',
          isLoading:true,
          isBtn:false,
          timeInterval:null,


          /* 支付提醒 */
          title:'请在新打开的页面完成支付',
          visible:false,
          id:null,
          payLoading:false,
          paystate:1,
          balance:0,
          amounts: 0,
          isShow:false,
          currentTime:'',
          isNoMoneyBtn:false,

          orderId:'',//订单Id
          sendVCodeTime: '',
          fullscreenLoading:false,
          outTime:0
        }
      },
      methods:{
        getPic(item) {
          return SZH.assets.image + item.ProductImgPath;
        },
        // 修改支付密码
        changePayPWD() {
          let self = this
          self.dialogVisible = true
          self.PayForm.Phone = self.user.PhoneNumberStr
          self.PayForm.PaymentPassword = self.user.PaymentPassword;
          self.$nextTick(()=>{
            self.$refs['PayForm'].resetFields();
          })
        },
        loadData() {
          var self = this;
          self.loading = true;
          self.$http.post(self.url.loadData, {}).then(result => {
            if (result.state == true && result.data != null) {
              for (var i in self.user) {
                if (result.data[i] != undefined) {
                  self.user[i] = result.data[i];
                } else {
                  self.user[i] = null;
                }
              }
              self.PaymentPassword = result.data.PaymentPassword;
              if (self.PaymentPassword) {
                self.Title = '修改支付密码'
              } else {
                self.Title = '设置支付密码'
              }
            } else {
            }
            self.loading = false;
          }, () => {
            self.loading = false;
          });
        },
        sendVCode() {
          let self = this;
          self.sendVCodeTime = 60;
          self.getCode()
          localStorage.setItem("sendvcodetime", 60);
          let index = setInterval(() => {
            if (self.sendVCodeTime > 0) {
              localStorage.setItem("sendvcodetime", --self.sendVCodeTime);
            } else {
              clearInterval(index)

              localStorage.removeItem("sendvcodetime")
            }
          }, 1000);
        },
        getCode() {
          let self = this;
          self.$http.post(self.url.SendVerifyCodeForWeb, {
            SmsTemplateType: 6,
            Phone: self.user.PhoneNumber,
            CustomId: self.user.CustomId,
            OldPassword: self.user.Password,
            Captcha: '',
          }).then(result => {
            if (result.state == true) {
              self.$message.success("验证码已发送成功")
            } else {
              self.$message.error(result.message)
            }
          })
        },
        savePayPwd() {
          let self = this;
          self.$refs['PayForm'].validate((valid) => {
            if (valid) {
              let NewPassword = hex_md5(self.PayForm.Password);
              let NewRePassword = hex_md5(self.PayForm.RePassword);
              self.loading  = true;
              self.$http.post(self.url.SetCustomPaymentPassword, {
                Password: NewPassword,
                RePassword: NewRePassword,
                VCode: self.PayForm.VCode,
                OldPassword: self.PayForm.PaymentPassword
              }).then(result => {
                if (result.state == true) {
                  self.$message.success('修改支付密码成功');
                  location.reload()
                } else {
                  self.$message.error(result.message)
                }
                self.loading  = false;
              })
            } else {
              self.loading  = false;
              return false;
            }
          });

        },


        getPriceOrderDetail(){
          let self = this;
          self.refreshPriceOrderFlag = true;
          self.$http.post(self.url.GetRefreshPriceFreezOrderDetail, {
              Data:self.Data.Orders[0].OrderId
          }).then(result => {
            if(result.State == 1 && result.Data && result.Data.length>0) {
              self.refreshPriceOrders = result.Data
            } else {
              self.refreshPriceOrders = []
            }
          }, () => { });
        },
        getDetail(){
          var self = this;
          if(self.orderId){
            self.fullscreenLoading = true;
            self.$http.post(self.url.get, {
              KeyValue:self.orderId
            }).then(result => {
              if (result.state == true) {
                for(var i in self.Data){
                  if(result.data[i] != undefined){
                    self.Data[i] = result.data[i];
                  }
                }
                self.amounts = self.Data.Amount;
                console.log('测试')
                var time = new Date(result.data.PayEndTimeStr).getTime() - new Date(self.currentTime).getTime();
                console.log(new Date(result.data.PayEndTimeStr).getTime())
                self.outTime = time;
                console.log(self.outTime)
                // var time = new Date(result.data.PayEndTime).getTime() - new Date().getTime();
                self.formatDuring(time);
                self.Data.timeStr = '0 秒';
                if(time<1000){
                  self.outTime = 0;
                }
                if(self.timeInterval){
                  clearInterval(self.timeInterval);
                  self.timeInterval = setInterval(()=>{
                    time = time-1000;
                    if(time>-1000){
                      self.formatDuring(time)
                    }else{
                      self.outTime = 0;
                      clearInterval(self.timeInterval)
                    }
                  },1000)
                }else{
                  self.timeInterval = setInterval(()=>{
                    time = time-1000;
                    if(time>-1000){
                      self.formatDuring(time);
                    }else{
                      self.outTime = 0;
                      clearInterval(self.timeInterval);
                    }
                  },1000)
                }
                self.fullscreenLoading = false;
              } else {
                self.fullscreenLoading = false;
                self.$message.error(result.message);
              }
            }, () => {
              self.$message.error('数据获取失败，请检查您的网络是否可用。');
            });
          }
        },

        formatDuring(mss) {
          console.log(this.outTime);
          var days = parseInt(mss / (1000 * 60 * 60 * 24));
          var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = (mss % (1000 * 60)) / 1000;
          this.Data.timeStr = days + " 天 " + hours + " 小时 "+ minutes + " 分钟 " + Math.ceil(seconds) + " 秒 ";
          //return days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
        },

        // 是否有支付密码
        hasPayPassword(){
          var self = this;
          self.$http.post(self.url.hasPayWord, {

          }).then(result => {
            if(result.State == 1) {
              if(result.Data == 1){
                self.isShow = true;
              }else{
                self.isShow = false;
              }

            }
            else {

            }
          }, () => { });
        },
        toSet(){
          this.$router.push({
            path:'/My/PaymentPasswordSettings',
            query: {existPayPWD: false}
          });
        },
        // 确认支付
        toPay(){
          var self = this;
          console.log("时间---")
          console.log(self.outTime)
          if(self.outTime<0 || self.outTime == 0){
            self.$message.error('订单已超时！');
            return
          }
          if(!self.form.Vcode){
            self.$message.error('请输入支付密码！');
            return
          }
          // if((self.Data.Payment[0].Balance+self.Data.Payment[0].Credit) < self.Data.Amount){
          //   self.$message.error('支付订单余额不足！');
          //   return
          // }
          self.form.Vcode = hex_md5(self.form.Vcode);
          self.form.OrderNo = self.Data.Orders[0].OrderId;
          self.fullscreenLoading = true;
          self.$http.post(self.url.pay,self.form).then(result =>{
            if(result.state == true){
              self.$router.push({
                path: '/My/OrderList',
                query:{ id: this.Data.Orders[0].OrderId }
              })
            }else{
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false
          }, () => {
            self.fullscreenLoading = false
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
        },
        turnTo(url) {
          this.$router.push({
            path: url
          })
        },
        getcuttent(){
          let self = this;
          self.$http.post(self.url.cuttent,{

          }).then(result =>{
            if(result.state == true && result.data){
              self.currentTime = result.data;
              console.log(self.currentTime);
              console.log(new Date(self.currentTime).getTime())
            }else{
            }
          }, () => {
            self.$message.error('数据保存失败，请检查您的网络是否可用。');
          });
        },
      },
      mounted() {
        this.orderId = this.$route.query.OrderId;
        this.getcuttent();
        this.getDetail();
        this.loadData();
        // this.hasPayPassword();
      }
    }
</script>
<style>

</style>
<style scoped>
  .box{
    display: flex;
    width: 1300px;
    margin: 15px auto;
  }
  .box div.order-box{
    width: 750px;
    padding: 0px 20px;
  }
  .box>div:first-child{
    border-right: 1px solid #ddd;
  }
  .box div.money-box{
    flex:1;
    padding-left: 50px;
    padding-right: 50px;
  }
  .order-info{
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    padding: 20px 0px;
    border-bottom: 1px solid #ddd;
  }
  .order-no{
    font-size: 18px;
    font-weight: 600;
    color: #666;
    margin-top: 20px;
  }
  .ul-li li{
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-top: 15px;
  }
  .ul-li li img{
    width: 25px;
    margin-right: 10px;
  }
  .pro-info{
    background: #f5f5f5;
    padding: 20px;
    display: flex;
    border-radius: 5px;
    align-items: center;
    margin-top: 15px;
  }
  .pro-img{
    width: 80px;
    height: 80px;
    background: #ffffff;
  }
  .pro-name{
    flex:1;
    font-size: 18px;
    font-weight: 600;
    color: #000;
    margin-left: 10px;
  }
  .pro-num{
    width: 100px;
    font-size: 16px;
    font-weight: 600;
  }
  .price{
    font-size: 36px;
    font-weight: 600;
    color: #ff6600;
  }
  .time{
    font-size: 16px;
    margin-top: 10px;
  }
  .money{
    font-size: 28px;
    font-weight: 600;
  }
  .name{
    font-size: 14px;
    margin-top: 25px;
  }
  .btn-pay{
    background: #0441A0;
    padding: 17px 0px;
    width: 100%;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/PayOrder/PayOrderTH.vue